import React, { useState } from 'react';
import style from './AlbumImageGallery.module.less';
import { ImageGalleryModal } from '../ImageGalleryModal';

interface AlbumImageGalleryProps {
  screenshots: any[];
}

const rotationDegs = [
  -6,
  7,
  -5,
  6,
  -7,
  3,
  -3,
  6,
  -6,
  7,
  -3,
  5,
  -3
];

export const AlbumImageGallery: React.FC<AlbumImageGalleryProps> = (props) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const openGallery = (index: number) => {
    setStartIndex(index)
    setModalVisible(true)
  }
  return (
    <>
      <div className={style.blocks}>
        {
          props.screenshots.map((screenshot, index) => 
            <div className={style.block} key={index}>
              <div className={style.cornerImages} style={{transform: `rotate(${rotationDegs[index] || 0}deg)`}} onClick={() => openGallery(index)}>
                <img src={screenshot.original} alt={`${screenshot.original}-${index}`} />
                <div className={style.topLeft} />
                <div className={style.topRight} />
                <div className={style.bottomLeft} />
                <div className={style.bottomRight} />
              </div>
            </div>
          )
        }
      </div>
      <ImageGalleryModal isOpen={modalVisible} onClose={() => setModalVisible(false)} images={props.screenshots} startIndex={startIndex} />
    </>
  )
};
